import React from 'react';
import mergeStyles from "../../util/mergeStyles";
import Box from "../../layout/Box/Box";
import responsive from "../../responsive";
export const DEFAULT_OFFSET = 8;
export const DEFAULT_TYPE = 'tooltip';
export const S = {
    content: {
        tooltip: {
            justifyContent: 'center',
            borderRadius: 4,
            paddingLeft: 8,
            paddingRight: 8,
            paddingTop: 4,
            paddingBottom: 4,
            backgroundColor: '#2C3651',
            borderColor: '#2C3651',
        },
        menu: {},
    },
};
export const Content = (props) => {
    const { children } = props;
    return children;
};
export const Anchor = (props) => {
    const { children, style } = props;
    return (<Box style={style}>
      {children}
    </Box>);
};
Content.calculateStyle = (props, contentProps) => mergeStyles({ ...props, offset: props.offset ?? DEFAULT_OFFSET }, S.content[props.type || 'menu'], [{ marginVertical: contentProps.offset }, !responsive.device.isWeb]);
Content.displayName = 'Content';
Anchor.displayName = 'Anchor';
export default {
    S,
    Content,
    Anchor,
    DEFAULT_OFFSET,
};
// TODO: Support Menu Popover (most likely through a modal)
// TODO: Mobile Parity
//# sourceMappingURL=PopoverCore.js.map